var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51956 1.50995H3.22193C2.75359 1.50995 2.30443 1.696 1.97327 2.02716C1.6421 2.35833 1.45605 2.80749 1.45605 3.27583V15.637C1.45605 16.1053 1.6421 16.5545 1.97327 16.8856C2.30443 17.2168 2.75359 17.4028 3.22193 17.4028H15.5831C16.0514 17.4028 16.5006 17.2168 16.8317 16.8856C17.1629 16.5545 17.3489 16.1053 17.3489 15.637V10.3393M7.19515 9.01492L14.2587 1.95142C14.6099 1.60016 15.0863 1.40283 15.5831 1.40283C15.829 1.40283 16.0726 1.45128 16.2998 1.54541C16.5271 1.63953 16.7335 1.7775 16.9075 1.95142C17.0814 2.12534 17.2194 2.33182 17.3135 2.55906C17.4076 2.7863 17.4561 3.02986 17.4561 3.27583C17.4561 3.52179 17.4076 3.76535 17.3135 3.99259C17.2194 4.21983 17.0814 4.42631 16.9075 4.60023L9.84396 11.6637L5.87074 12.9881L7.19515 9.01492Z",
    stroke: "#AA8453",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.bdf8a8dcc0537b50928bc064cce8467b.svg";
export { ForwardRef as ReactComponent };